'use client';
import { useEffect, useState } from 'react';

/**
 * 미디어 쿼리 일치 여부. 서버 렌더와 첫 클라이언트 렌더는 false로 같게 두고 마운트 뒤에 판정한다.
 */
const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const update = () => setMatches(mediaQuery.matches);
    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, [query]);

  return matches;
};

export default useMediaQuery;
